import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
import { AdminLayout } from './components/admin/AdminLayout';
import { ProtectedRoute } from './components/admin/ProtectedRoute';
import Home from './pages/Home';
import SubmitStory from './pages/SubmitStory';
import StoryDetails from './pages/StoryDetails';
import AdminLogin from './pages/admin/Login';
import AdminDashboard from './pages/admin/Dashboard';
import AdminStartups from './pages/admin/Startups';
import AddStartup from './pages/admin/AddStartup';
import AdminStories from './pages/admin/Stories';
import PendingSubmissions from './pages/admin/PendingSubmissions';
import ExpertRequests from './pages/admin/ExpertRequests';
import Articles from './pages/admin/Articles';
import ViewStartup from './pages/admin/ViewStartup';
import ListingRequests from './pages/admin/ListingRequests';
import Country from './pages/admin/master/Country';
import State from './pages/admin/master/State';
import City from './pages/admin/master/City';
import Industry from './pages/admin/master/Industry';
import EmployeeCount from './pages/admin/master/EmployeeCount';
import Topics from './pages/admin/master/Topics';
import Tags from './pages/admin/master/Tags';
import { Toaster } from './components/ui/sonner';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <div className="App min-h-screen flex flex-col">
        <BrowserRouter>
          <Routes>
            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="listing-requests" element={<ListingRequests />} />
              <Route path="startups" element={<AdminStartups />} />
              <Route path="startups/add" element={<AddStartup />} />
              <Route path="startups/:id" element={<ViewStartup />} />
              <Route path="stories" element={<AdminStories />} />
              <Route path="stories/pending-submissions" element={<PendingSubmissions />} />
              <Route path="expert-requests" element={<ExpertRequests />} />
              <Route path="articles" element={<Articles />} />
              <Route path="master/country" element={<Country />} />
              <Route path="master/state" element={<State />} />
              <Route path="master/city" element={<City />} />
              <Route path="master/industry" element={<Industry />} />
              <Route path="master/employee-count" element={<EmployeeCount />} />
              <Route path="master/topics" element={<Topics />} />
              <Route path="master/tags" element={<Tags />} />
            </Route>

            {/* Public Story Submission Route (no navigation/footer) */}
            <Route path="/submit-story/:storyToken" element={<SubmitStory />} />
            
            {/* Story Details Page (no navigation/footer) */}
            <Route path="/story/:slug" element={<StoryDetails />} />

            {/* Public Routes */}
            <Route
              path="/*"
              element={
                <>
                  <Navigation />
                  <main className="flex-1">
                    <Routes>
                      <Route path="/" element={<Home />} />
                      <Route path="/startups" element={<ComingSoon page="Startups" />} />
                      <Route path="/stories" element={<ComingSoon page="Stories" />} />
                      <Route path="/interviews" element={<ComingSoon page="Interviews" />} />
                      <Route path="/events" element={<ComingSoon page="Events" />} />
                      <Route path="/lists" element={<ComingSoon page="Lists" />} />
                      <Route path="/about" element={<ComingSoon page="About" />} />
                      <Route path="/list-startup" element={<ComingSoon page="List Your Startup" />} />
                    </Routes>
                  </main>
                  <Footer />
                </>
              }
            />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </div>
    </AuthProvider>
  );
}

// Coming Soon placeholder component
const ComingSoon = ({ page }) => (
  <div className="container mx-auto px-4 py-20 text-center">
    <h1 className="text-4xl font-bold font-heading mb-4">{page}</h1>
    <p className="text-xl text-muted-foreground">Coming soon! We're working on bringing you amazing content.</p>
  </div>
);

export default App;
